// extracted by mini-css-extract-plugin
export default {"listItem":"marketSelector_listItem__L-VaU","subText":"marketSelector_subText__CSt-y"};